import { useStore } from 'effector-react';
import { routes } from 'features/fallback/routes';
import { errorType$ } from 'model/error.model';
import { fallbackCancel, openExitPopup } from 'model/flows/fallback.model';
import { localizationOptions$, useLocalization } from 'model/localization.model';
import { FunctionalComponent, h } from 'preact';
import { styled } from 'linaria/react';

import { ExitIcon } from 'ui/icons/exit-icon';
import { GlobeIcon } from 'ui/icons/globe-icon';
import { Button } from 'ui/atoms/button';
import { LeftArrowIcon } from 'ui/icons/left-arrow-icon';
import { SatelliteIcon } from 'ui/icons/satellite-icon';
import { $route, navigate } from 'libs/router/navigation.store';
import { openLocalizationPopup } from 'model/localization.model';

export const Header: FunctionalComponent = () => {
	const t = useLocalization();
	const route = useStore($route);
	const errorType = useStore(errorType$);
	const options = useStore(localizationOptions$);

	const handleExit = () => {
		if (errorType === null) {
			openExitPopup();
		} else {
			fallbackCancel(null);
		}
	};

	return (
		<HeaderContainer>
			{route === routes.welcome ? (
				options.languageSelector ? (
					<Button
						type={'default'}
						style={{ paddingLeft: 0 }}
						onClick={() => openLocalizationPopup()}
						name={'open.language.popup'}
					>
						<GlobeIcon
							fill={'var(--text-secondary)'}
						/>
					</Button>
				) : (
					<div/>
				)
			) : route === routes.connected ? (
				<HeaderButton>
					<SatelliteIcon
						fill={'var(--text-secondary)'}
					/>
					{t('flow.bridge.header')}
				</HeaderButton>
			) : !route.includes('error') ? (
				<HeaderButton onClick={() => navigate(routes.welcome)}>
					<LeftArrowIcon/>
					{t('flow.tabs.header')}
				</HeaderButton>
			) : <div/>}
			<Button
				style={{ paddingRight: 0 }}
				type={'default'}
				onClick={handleExit}
				name={'open.exit.popup'}
			>
				<ExitIcon
					fill={'var(--text-secondary)'}
				/>
			</Button>
		</HeaderContainer>
	);
};

const HeaderButton = styled('button')`
  display: flex;
  align-items: center;
  background: none;
  border: none;
  outline: none;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  color: var(--text-secondary);
  cursor: pointer;
	padding: 0;

  svg {
    margin-right: 8px;
  }
`;

const HeaderContainer = styled('div')`
  display: flex;
  justify-content: space-between;
  padding: 8px 32px;
`;
